/*import Address from '@/types/soap/elga/Address';
import Telecom from '@/types/soap/elga/Telecom';*/
import Vue from 'vue';
import PatPatient from '@/types/Patient';
import { Geschlecht } from '@/types/Geschlecht';
import store from '@/store/index';

export enum Gender {
    Male = 'male',
    Female = 'female',
    Other = 'other',
}

export default class Patient {
    /* interne ID des Patienten */
    public bPK!: string;
    /* Akad. Titel */
    public prefix?: string;
    /* Akad. Titel */
    public suffix?: string;
    /* Vorname */
    public family!: string;
    /* Nachname */
    public given!: string[];
    /* Geschlecht (mögliche Werte: male, female, unknown, other) */
    public gender!: string;
    /* Geburtsdatum (Format: YYYY-MM-DD) */
    public birthdate?: string;
    /* Stadt */
    public city?: string;
    /* Adresszeile – Straße + Hausnummer */
    public address?: string;
    /*Postleitzahl*/
    public postalcode?: string;
    /* Bundesland */
    public state?: string;
    /* Staatscode ISO-3166-1 Alpha 3 (default: AUT) */
    public country?: string;
    /* Sozialversicherungsnummer */
    public ssno!: string;

    public get nachname(): string {
        return this.family ?? '';
    }

    public get vorname(): string {
        return this.given?.join(' ') ?? '';
    }

    public get nachnameVorname(): string {
        const { nachname, vorname } = this;
        return nachname + (vorname !== '' ? ` ${vorname}` : '');
    }

    public get geburtsdatum(): string {
        return Vue.prototype.$d(this.birthdate);
    }

    public get adresse(): string {
        const adresse = [];

        if (this.address) {
            if (this.postalcode || this.city) {
                adresse.push(this.address + ',');
            } else {
                adresse.push(this.address);
            }
        }

        if (this.postalcode) {
            adresse.push(this.postalcode);
        }

        if (this.city) {
            adresse.push(this.city);
        }

        if (this.country) {
            const land = store.state.laender.laender.find(({ land }) => land === this.country);
            adresse.push(land?.bezeichnung ?? this.country);
        }

        return adresse
            .filter((str: string | undefined) => str && str !== '')
            .join(' ');
    }

    public get svnr(): string {
        return this.ssno ?? '';
    }

    public get geschlecht(): string | null {
        switch (this.gender) {
            case Gender.Male:
                return Geschlecht.Maennlich;
            case Gender.Female:
                return Geschlecht.Weiblich;
            case Gender.Other:
                return Geschlecht.Divers;
            default:
                return null;
        }
    }

    constructor(data?: Partial<Patient>) {
        Object.assign(this, data);
    }

    public hasSameNachnameAs(patient: PatPatient): boolean {
        return patient.nachname?.toLocaleUpperCase()?.trim() ===
            this.family?.toLocaleUpperCase()?.trim();
    }

    public hasSameVornameAs(patient: PatPatient): boolean {
        const vorname = patient.vorname?.toLocaleUpperCase()?.trim();
        return vorname === this.given?.join(' ')?.toLocaleUpperCase() ||
            vorname === this.given?.join('-')?.toLocaleUpperCase();
    }

    public hasSameGeburtsdatumAs(patient: PatPatient): boolean {
        return patient.geburtsdatum === this.birthdate;
    }

    public hasSameSvnrAs(patient: PatPatient): boolean {
        return patient.svnr === this.ssno;
    }
}
